<template>
  <div class="E3D-video-Detail">
    <div v-loading="loading"></div>
    <div v-if="!loading" class="content">
      <breadcrumb :refer="refer"></breadcrumb>
      <div class="Detail-title" v-if="Detail.title"> {{ Detail.title }} </div>
      <div class="mb15 co-999" v-if="Detail.abstract"> {{ Detail.abstract }} </div>
      <div class="video-container">
        <div class="Videos" @contextmenu.stop="$event.returnValue = false">
          <div v-if="!video.startPlay" class="Videos-shade flex0">
            <img class="cur" src="~@/assets/PC/fenceDetail/player.png" alt="" @click="startVideo">
          </div>
          <video-player class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="false"
            :options="playerOptions"
            @statechanged="playerStateChanged($event)"
            >
          </video-player>
          <!-- 有海报按钮才显示 -->
           <!-- v-if="Detail.isHavePoster" -->
          <div class="video-poster-btn-box" >
            <div class="video-poster-btn" v-if="Detail.isHavePoster" @click="createPoster">生成海报</div>
            <div class="video-poster-btn" @click="goQuestion">我要提问</div>
          </div>
        </div>
      </div>
    </div>
    <xy-alert-box
      v-show="AlertData.state"
      :title="AlertData.title"
      :imgUrl="AlertData.imgUrl"
      :btns="AlertData.btns"
      @alertClose="alertClose"
    >
    </xy-alert-box>
    <!-- 登录执行弹窗 -->
    <shadeAlert :shadeConfig="shadeConfig" @closeAlert="closeAlertChange" />
    <!-- 海报弹窗 -->
    <div class="shade flex0 shade1" v-show="pageLoading || posterShow" v-loading="pageLoading">
      <div class="alert-popUp">
        <div class="picture">
          <img :src="posterImg" v-show="posterShow" alt="" class="poster_img">
          <div class="show_close" @click="closePoster" v-show="posterShow">
            <i class="el-icon-circle-close cur"></i>
          </div>
        </div>
        <div class="save fx11" v-show="posterShow">
          {{clientWidth > 750 ? '右键保存图片' : '长按保存图片'}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/Breadcrumb/index.vue'
import xyAlertBox from '@/components/xyAlertBox'
import shadeAlert from '@/components/shadeAlert/index.vue'

import { E3DCourse, Learning, BasicData } from '@/api/E3D.js'
import * as Fence from '@/api/library.js'
import { GetShareData, GetWxShares } from '@/utils/common'
import { mapState } from 'vuex';
export default {
  name: 'E3DVideoDetail',
  data () {
    return {
      loading: true,
      // !面包屑
      refer: [
        { name: '首页', href: '/' },
        { name: 'E3D视频', href: '/Home/E3DVideo' },
        { name: '', href: ''}
      ],
      // !video 组件配置
      playerOptions: {
        playbackRates: [1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      video: {
        // @ 视频是否播放
        startPlay: false,
        // @ 当前视频播放倍速
        rate: 1,
        // @ 定时器秒数
        setTime: 0
      },
      // ! 详情数据
      Detail: {
        id: '',
        title: '',
        abstract: '',
        isHavePoster: false,
      },
      // !弹窗配置
      shadeConfig: {},
      posterShow: false,
      posterImg: '',
      pageLoading: false,
      params: {
        // !视频播放时长
        watchTime: 0,
        // !id
        id: this.$route.query.id
      },
      // ! 徽章弹窗
      AlertData: {
        state: false,
        title: '',
        imgUrl: '',
        btns: [
          {
            id: 1,
            url: '/Home/Profile/badge',
            title: '查看勋章',
            IsLink: false
          }
        ]
      },
      code: '',
      // !是否有参数
      isCode: false,
    }
  },
  mounted() {
    this.code = this.$route.query.code || ''
    if(this.code){
      this.isCode = true
    }else{
      this.isCode = false
      this.code = 'E3DVideo'
    }

    console.log(this.$route.query)
    if(!this.token) {
      this.$toast('请先登录再来浏览精彩视频吧！')
      if(this.isCode) {
        this.$router.push('/Home/Product/' + this.code)
      } else {
        this.$router.push('/Home/E3DVideo')
      }
      return false
    }
    this.GetNavList()
    GetShareData(1, "E3DVideoDetail", this.$route.query.id)
  },
  methods: {
    // ! 点击开始播放
    startVideo() {
      this.$refs.videoPlayer.player.play();
      this.video.startPlay = true;
    },
    // !获取视频分类
    GetNavList () {
      BasicData({code: this.code}).then(res => {
        if (res.status === 1) {
          this.refer[1].name = res.data.title
          if(this.isCode) {
            this.refer[1].href = '/Home/Product/' + this.code
          } else {
            this.refer[1].href = '/Home/E3DVideo'
          }
          if(!res.data.isHaveCourse){
            this.$toast('当前课程分类没有视频！')
            if(this.isCode) {
              this.$router.push('/Home/Product/' + this.code)
            } else {
              this.$router.push('/Home/E3DVideo')
            }
          }else{
            this.VideoInit()
          }
        } else if(res.status === -100) {
          this.$toast(res.message)
          this.$router.push('/Home/Index')
        } else {
          this.$toast(res.message)
        }
      })
    },
    // ! 获取当前播放倍速
    VideoInit() {
      E3DCourse({id: this.$route.query.id}).then(res => {
        if (res.status === 1) {
          const share = {
            title: res.data.title,
            // desc: res.data.abstract
          }

          GetWxShares(share)
          this.refer[this.refer.length - 1].name = res.data.title
          this.Detail = res.data;
          this.playerOptions.sources[0].src = res.data.videoUrl;
          this.loading = false;
          this.$nextTick(()=> {
            const Video = document.querySelector('.vjs-playback-rate-value');
            Video.addEventListener('DOMNodeInserted',e => {
              this.video.rate = e.target.data.split('x')[0] * 1;
            });
          })
        } else {
          this.$toast(res.message);
          this.timeout = setTimeout(()=> {
            if(this.isCode) {
              this.$router.push('/Home/Product/' + this.code)
            } else {
              this.$router.push('/Home/E3DVideo')
            }
          }, 300)
        }
      })
    },
    // ! 状态监听
    playerStateChanged(e) {
      if(e.play || e.playing) {
        if(!this.timer) {
          this.setTime()
        }
      } else if(e.waiting || e.pause) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    // ! 读取播放时长
    setTime() {
      this.timer = setInterval(()=>{
        this.video.setTime++;
        this.params.watchTime = this.params.watchTime + 1 * this.video.rate;
        if(this.video.setTime % 5 == 0) {
          this.setLearning()
        }
      },1000)
    },
    // ! 学习进度持续回调
    setLearning() {
      const Time = JSON.parse(JSON.stringify(this.params))
      this.params.watchTime = 0
      Learning(Time).then(res => {
        if (res.status === 1) {
          this.alertBox(res.data)
        }
      })
    },
    // ! 获取勋章弹窗
    alertBox(imgUrl) {
      if (imgUrl.length > 0 && imgUrl[0].imgUrl) {
        // this.AlertData.title = '恭喜您获得“' +  title + '”成就勋章！'
        this.AlertData.title = '恭喜您获得新的成就勋章！'
        this.AlertData.imgUrl = imgUrl
        this.AlertData.state = true
      }
    },
    // ! 关闭弹窗
    alertClose() {
      this.AlertData.state = false
    },
    // !关闭登录指引弹窗
    closeAlertChange(state) {
      this.shadeConfig.show = state;
    },
    // ! 生成海报
    createPoster() {
      if (!this.$store.state.token) {
        // 取消登录限制
        this.shadeConfig = {
          show: true, // 展示隐藏弹窗
          closeIcon: true, // 是否需要关闭按钮
          title: "您还没有登录，<br/>请登录后再来生成海报吧！",
          text: "", // 弹窗内容
          btnType: "link", // 按钮形式
          btnList: [
            {
              text: "已有剑盟账号，前往登录",
              link: "/Login?redirectUrl=" + this.$route.fullPath,
            },
            {
              text: "没有账号，立即注册",
              link: "/Register?redirectUrl=" + this.$route.fullPath,
            },
          ],
        };
      } else {
        this.pageLoading = true;
        const Id = JSON.stringify(this.$route.query.id);
        Fence.GetPosterUrl(Id).then((res) => {
          console.log(res);
          this.pageLoading = false;
          if(res.status == 1) {
            this.posterImg = res.message;
            this.posterShow = true;
          }else{
            this.$toast(res.message);
          }
        });
      }
    },
    // ! 关闭海报
    closePoster() {
      this.posterShow = false;
    },
    // ! 我要提问
    // goQuestion() {
    //   this.$router.push('/Home/QuestionSec/article?type=1&relationId=' + this.$route.query.id)
    // },
    // ! 我要提问
    goQuestion() {
      if (!this.$store.state.token) {
        // 取消登录限制
        this.shadeConfig = {
          show: true, // 展示隐藏弹窗
          closeIcon: true, // 是否需要关闭按钮
          title: "您还没有登录，<br/>请登录后再来生成提问吧！",
          text: "", // 弹窗内容
          btnType: "link", // 按钮形式
          btnList: [
            {
              text: "已有剑盟账号，前往登录",
              link: "/Login?redirectUrl=" + this.$route.fullPath,
            },
            {
              text: "没有账号，立即注册",
              link: "/Register?redirectUrl=" + this.$route.fullPath,
            },
          ],
        };
      } else {
        this.$router.push("/Home/ForumSec/Article?type=2&relationId=" + this.$route.query.id);
      }
    },
  },
  components: {
    breadcrumb,
    xyAlertBox,
    shadeAlert
  },
  computed: {
    ...mapState(['token', 'clientWidth'])
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timeout)
    this.timer = null
  }
}
</script>

<style lang="scss" scoped>
  @import './index.scss'
</style>